"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2510],{

/***/ 62510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ getSellerData; },
/* harmony export */   "LP": function() { return /* binding */ getStoreInfo; },
/* harmony export */   "Po": function() { return /* binding */ hasFlagshipStoreTag; },
/* harmony export */   "Xo": function() { return /* binding */ getVendorStoreInfo; },
/* harmony export */   "av": function() { return /* binding */ getVendorStoreList; },
/* harmony export */   "jx": function() { return /* binding */ getListSearchStore; },
/* harmony export */   "vp": function() { return /* binding */ getSearchStoreByName; }
/* harmony export */ });
/* unused harmony export getCachedVendorStores */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var clients_Clients__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38307);
/* harmony import */ var clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15537);
/* harmony import */ var constants_Enums__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71569);
/* harmony import */ var services_ProductServiceV2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5108);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66225);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46203);
/* harmony import */ var utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49327);










/**
 * from the seller, fill data like name, link to store...
 * @param {object} param0
 * @param {object} param0.seller
 * @param {string[]=} param0.tags
 * @param {boolean=} param0.isSkipShortName
 * @returns
 * @example
 * const seller = getSellerData({ seller: mapSeller.get(seller.code) });
 */ function getSellerData(param) {
    var _seller = param.seller, seller = _seller === void 0 ? {} : _seller, _tags = param.tags, tags = _tags === void 0 ? [] : _tags, _isSkipShortName = param.isSkipShortName, isSkipShortName = _isSkipShortName === void 0 ? false : _isSkipShortName;
    var ref, ref1;
    var isVAT = (tags === null || tags === void 0 ? void 0 : tags.indexOf("HOADONNHANH")) >= 0 || false;
    var sellerName = "";
    var isDisplayStore = false;
    var fullNameSeller = "";
    var individualNonVatSellerName = "";
    var sellerCode = (seller === null || seller === void 0 ? void 0 : seller.code) || (seller === null || seller === void 0 ? void 0 : seller.sellerCode);
    var sellerSlug = (seller === null || seller === void 0 ? void 0 : seller.slug) || "";
    var linkSeller = (seller === null || seller === void 0 ? void 0 : (ref = seller.landingPage) === null || ref === void 0 ? void 0 : ref.startsWith("https://try.thuocsi.vn")) ? seller === null || seller === void 0 ? void 0 : seller.landingPage : "/seller-products/".concat(sellerCode, "/").concat((seller === null || seller === void 0 ? void 0 : seller.slugStore) || (seller === null || seller === void 0 ? void 0 : seller.sellerType) == "ENTERPRISE" ? sellerSlug : "");
    // nếu không có sellerinfo => hiện default
    if (seller) {
        if (seller.isInternal || seller.sellerClass == "INTERNAL") {
            isDisplayStore = true;
            fullNameSeller = seller.sellerName || seller.name || "MEDX";
            if (isVAT) {
                sellerName = seller.shortName || seller.sellerCode || seller.code || "MEDX";
            }
        } else if ((seller === null || seller === void 0 ? void 0 : seller.sellerType) === "ENTERPRISE") {
            isDisplayStore = true;
            sellerName = (seller === null || seller === void 0 ? void 0 : seller.name) || "";
            if (!isSkipShortName) {
                if (seller.shortName) {
                    sellerName = seller === null || seller === void 0 ? void 0 : seller.shortName;
                }
                // fallback for all case
                if (seller.displayName) {
                    sellerName = seller === null || seller === void 0 ? void 0 : seller.displayName;
                }
            }
            fullNameSeller = (seller === null || seller === void 0 ? void 0 : seller.fullName) || "";
        } else {
            sellerName = "Đối T\xe1c Của ".concat(constants_Enums__WEBPACK_IMPORTED_MODULE_2__/* .BRAND_NAME */ .RS);
            var ref2;
            individualNonVatSellerName = "Nh\xe0 b\xe1n h\xe0ng ".concat((ref2 = seller === null || seller === void 0 ? void 0 : seller.sellerID) !== null && ref2 !== void 0 ? ref2 : "");
            isDisplayStore = false;
            fullNameSeller = "Đối T\xe1c Của ".concat(constants_Enums__WEBPACK_IMPORTED_MODULE_2__/* .BRAND_NAME */ .RS);
            linkSeller = "/doitac/".concat(sellerCode);
        }
    }
    var storeSlug = (seller === null || seller === void 0 ? void 0 : (ref1 = seller.sellerStore) === null || ref1 === void 0 ? void 0 : ref1.slug) || sellerSlug;
    var linkStore = (seller === null || seller === void 0 ? void 0 : seller.isVip) ? sysconfig__WEBPACK_IMPORTED_MODULE_4__/* .DOMAIN_FLAGSHIP_STORE.replace */ .cb.replace("{seller}", storeSlug) || "/flagship-store/".concat(storeSlug) : "/seller/".concat(storeSlug);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        sellerName: sellerName,
        linkStore: linkStore,
        linkSeller: linkSeller,
        isDisplayStore: isDisplayStore,
        fullNameSeller: fullNameSeller,
        individualNonVatSellerName: individualNonVatSellerName
    }, seller);
}
function getStoreInfo(_) {
    return _getStoreInfo.apply(this, arguments);
}
function _getStoreInfo() {
    _getStoreInfo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ctx, slug, infoResult, _tmp, storeInfo, countTotalRes, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .getStoreInfoForWeb */ .jV)((_tmp.ctx = ctx, _tmp.slug = slug, _tmp))
                    ];
                case 1:
                    infoResult = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(infoResult)) {
                        return [
                            2,
                            null
                        ];
                    }
                    storeInfo = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(infoResult);
                    _tmp1 = {};
                    return [
                        4,
                        services_ProductServiceV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"].loadProductWithFilter */ .ZP.loadProductWithFilter((_tmp1.ctx = ctx, _tmp1.limit = 1, _tmp1.filter = {
                            seller: storeInfo.sellerCode
                        }, _tmp1))
                    ];
                case 2:
                    countTotalRes = _state.sent();
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(countTotalRes)) {
                        storeInfo.numberProducts = countTotalRes.total;
                        storeInfo.numberProductDisplay = countTotalRes.total;
                    }
                    return [
                        2,
                        storeInfo
                    ];
            }
        });
    });
    return _getStoreInfo.apply(this, arguments);
}
function getListSearchStore(_) {
    return _getListSearchStore.apply(this, arguments);
}
function _getListSearchStore() {
    _getListSearchStore = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ctx, body, listStoreActiveRes, _tmp, data, total, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, body = param.body;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchSellerStoreV2 */ .HS)((_tmp.ctx = ctx, _tmp.body = body, _tmp))
                    ];
                case 1:
                    listStoreActiveRes = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(listStoreActiveRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(listStoreActiveRes);
                    total = listStoreActiveRes.total;
                    _tmp1 = {};
                    // const topProductsRes = await Promise.all(promiseAll);
                    // const topProductsArr = [];
                    // topProductsRes.forEach((ele) => {
                    //   topProductsArr.push(getData(ele));
                    // });
                    // const topProducts = topProductsArr.map((item) => {
                    //   const sellerCode = item[0]?.sellerCode || '';
                    //   return { sellerCode, topProducts: item };
                    // });
                    // const sellerMapTopProduct = data.map((item) => {
                    //   const { code } = item;
                    //   const obj = topProducts.find((ele) => ele.sellerCode === code);
                    //   return { ...item, product: { sellerCode: code, topProducts: obj?.topProducts.slice(0, 3) || {} } };
                    // });
                    return [
                        2,
                        (_tmp1.total = total, _tmp1.storeData = data, _tmp1)
                    ];
            }
        });
    });
    return _getListSearchStore.apply(this, arguments);
}
function getSearchStoreByName(_) {
    return _getSearchStoreByName.apply(this, arguments);
}
function _getSearchStoreByName() {
    _getSearchStoreByName = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ctx, params, listStoreRes, _tmp, data, total, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, params = param.params;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchStoreByTextV2 */ .J5)((_tmp.ctx = ctx, _tmp.params = params, _tmp))
                    ];
                case 1:
                    listStoreRes = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(listStoreRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(listStoreRes);
                    total = listStoreRes.total;
                    _tmp1 = {};
                    // const topProductsArr = [];
                    // topProductsRes.forEach((ele) => {
                    //   topProductsArr.push(getData(ele));
                    // });
                    // const topProducts = topProductsArr.map((item) => {
                    //   const sellerCode = item[0]?.sellerCode || '';
                    //   return { sellerCode, topProducts: item };
                    // });
                    // const sellerMapTopProduct = data.map((item) => {
                    //   const { code } = item;
                    //   const obj = topProducts.find((ele) => ele.sellerCode === code);
                    //   return { ...item, product: { sellerCode: code, topProducts: obj?.topProducts.slice(0, 3) || {} } };
                    // });
                    return [
                        2,
                        (_tmp1.total = total, _tmp1.storeData = data, _tmp1)
                    ];
            }
        });
    });
    return _getSearchStoreByName.apply(this, arguments);
}
function getVendorStoreInfo(_) {
    return _getVendorStoreInfo.apply(this, arguments);
}
function _getVendorStoreInfo() {
    _getVendorStoreInfo = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ctx, slug, _getStoreInfo, getStoreInfo, vendorStoreRes, _tmp, vendorStore, countTotalRes, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, slug = param.slug, _getStoreInfo = param.getStoreInfo, getStoreInfo = _getStoreInfo === void 0 ? false : _getStoreInfo;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchVendorStore */ .It)((_tmp.ctx = ctx, _tmp.body = {
                            q: {
                                slug: slug
                            },
                            getStoreInfo: getStoreInfo,
                            queryForWeb: true
                        }, _tmp))
                    ];
                case 1:
                    vendorStoreRes = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(vendorStoreRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    vendorStore = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getFirst */ .Xi)(vendorStoreRes);
                    _tmp1 = {};
                    return [
                        4,
                        services_ProductServiceV2__WEBPACK_IMPORTED_MODULE_3__/* ["default"].loadProductWithFilter */ .ZP.loadProductWithFilter((_tmp1.ctx = ctx, _tmp1.limit = 1, _tmp1.filter = {
                            seller: vendorStore.sellerCode
                        }, _tmp1))
                    ];
                case 2:
                    countTotalRes = _state.sent();
                    if ((0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(countTotalRes)) {
                        vendorStore.numberProducts = countTotalRes.total;
                        vendorStore.numberProductDisplay = countTotalRes.total;
                    }
                    return [
                        2,
                        vendorStore
                    ];
            }
        });
    });
    return _getVendorStoreInfo.apply(this, arguments);
}
function getVendorStoreList(_) {
    return _getVendorStoreList.apply(this, arguments);
}
function _getVendorStoreList() {
    _getVendorStoreList = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(param) {
        var ctx, body, listStoreActiveRes, _tmp, data, total, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    ctx = param.ctx, body = param.body;
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchVendorStoreV2 */ .V$)((_tmp.ctx = ctx, _tmp.body = body, _tmp))
                    ];
                case 1:
                    listStoreActiveRes = _state.sent();
                    if (!(0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .isValid */ .JY)(listStoreActiveRes)) {
                        return [
                            2,
                            null
                        ];
                    }
                    data = (0,clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .getData */ .Yu)(listStoreActiveRes);
                    total = listStoreActiveRes.total;
                    _tmp1 = {};
                    return [
                        2,
                        (_tmp1.total = total, _tmp1.storeData = data, _tmp1)
                    ];
            }
        });
    });
    return _getVendorStoreList.apply(this, arguments);
}
/**
 * Get vendor store with status=ACTIVE from cache or fetch from API
 * @returns {Promise<Array>}
 */ function getCachedVendorStores() {
    return _getCachedVendorStores.apply(this, arguments);
}
function _getCachedVendorStores() {
    _getCachedVendorStores = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var FIELDS, cachedVendorStores, res, _tmp, data, allData, offset, _tmp1, vendorStores;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    FIELDS = [
                        "code",
                        "name",
                        "url",
                        "slug",
                        "landingPage",
                        "logo",
                        "allProductTag",
                        "primaryColor",
                        "titleColor",
                        "backgroundColor",
                        "borderAvatarColor"
                    ];
                    cachedVendorStores = (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .getWithExpiry */ .jE)(utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .CACHE_KEY.VENDOR_STORES */ .oy.VENDOR_STORES);
                    if (cachedVendorStores) {
                        return [
                            2,
                            cachedVendorStores.map(function(data) {
                                return (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .deserializeFunc */ .OW)(data, FIELDS);
                            })
                        ];
                    }
                    _tmp = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchVendorStore */ .It)((_tmp.body = {
                            offset: 0,
                            limit: clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .MAX_LIMIT */ .OE,
                            q: {
                                status: "ACTIVE"
                            }
                        }, _tmp))
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== "OK") {
                        console.error("[Error] Get vendorStore", res);
                        return [
                            2,
                            []
                        ];
                    }
                    data = res.data || [];
                    allData = data;
                    offset = data.length;
                    _state.label = 2;
                case 2:
                    if (!(data.length === clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .MAX_LIMIT */ .OE)) return [
                        3,
                        4
                    ];
                    _tmp1 = {};
                    return [
                        4,
                        (0,clients_SellerClient__WEBPACK_IMPORTED_MODULE_1__/* .searchVendorStore */ .It)((_tmp1.body = {
                            offset: offset,
                            limit: clients_Clients__WEBPACK_IMPORTED_MODULE_0__/* .MAX_LIMIT */ .OE,
                            q: {
                                status: "ACTIVE"
                            }
                        }, _tmp1))
                    ];
                case 3:
                    res = _state.sent();
                    if (res.status !== "OK") {
                        return [
                            3,
                            4
                        ];
                    }
                    data = res.data;
                    allData = allData.concat(data);
                    offset += data.length;
                    return [
                        3,
                        2
                    ];
                case 4:
                    vendorStores = allData.filter(function(item) {
                        return item.status === "ACTIVE";
                    }).map(function(p) {
                        return (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .serializeFunc */ .eX)(p, FIELDS);
                    });
                    // Update cache
                    (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .setWithExpiry */ .w4)(utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .CACHE_KEY.VENDOR_STORES */ .oy.VENDOR_STORES, vendorStores);
                    return [
                        2,
                        vendorStores.map(function(data) {
                            return (0,utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .deserializeFunc */ .OW)(data, FIELDS);
                        })
                    ];
            }
        });
    });
    return _getCachedVendorStores.apply(this, arguments);
}
var hasFlagshipStoreTagCount = 0;
/**
 * Check product tags to see if it has a vendor store tag
 * @param {Array<string>} productTags
 * @returns {Promise<boolean>}
 */ function hasFlagshipStoreTag() {
    return _hasFlagshipStoreTag.apply(this, arguments);
}
function _hasFlagshipStoreTag() {
    _hasFlagshipStoreTag = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var productTags, vendorStores, i;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    productTags = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : [];
                    if ((productTags === null || productTags === void 0 ? void 0 : productTags.length) <= 0) return [
                        2,
                        false
                    ];
                    if (productTags.indexOf("DUREX") >= 0) return [
                        2,
                        true
                    ];
                    if (productTags.indexOf("SANOFI") >= 0) return [
                        2,
                        true
                    ];
                    // HACK:
                    // When the function is called for the first time, it will trigger API and
                    // save to localStorage. The subsequent calls will wait for the cached data
                    // to be available (assumption: the API is finished after 2 seconds).
                    // If there is already a cached data, we don't need to wait
                    hasFlagshipStoreTagCount += 1;
                    if (!(hasFlagshipStoreTagCount > 1 && !localStorage.getItem(utils_localStorageUtils__WEBPACK_IMPORTED_MODULE_6__/* .CACHE_KEY.VENDOR_STORES */ .oy.VENDOR_STORES))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .sleep */ ._v)(2)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        getCachedVendorStores()
                    ];
                case 3:
                    vendorStores = _state.sent();
                    // Loop though all vendor stores, check if productTags contains any of the allProductTag
                    for(i = 0; i < vendorStores.length; i++){
                        if (productTags.indexOf(vendorStores[i].allProductTag) >= 0) return [
                            2,
                            true
                        ];
                    }
                    return [
                        2,
                        false
                    ];
            }
        });
    });
    return _hasFlagshipStoreTag.apply(this, arguments);
}


/***/ })

}]);